import { Users, Wifi, Heart, Instagram, Star, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

function StatCard({ icon: Icon, label, value, color = "text-blue-600" }) {
  return (
    <Card>
      <CardContent className="p-4 flex items-center gap-3">
        <div className={`p-2 rounded-lg bg-gray-100`}>
          <Icon className={`h-5 w-5 ${color}`} />
        </div>
        <div>
          <p className="text-2xl font-bold">{value ?? 0}</p>
          <p className="text-xs text-gray-500">{label}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export default function WiFiStatsCards({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard icon={Users} label="Total de leads" value={stats.total_leads} color="text-blue-600" />
      <StatCard icon={Wifi} label="Visitas totais" value={stats.total_visits} color="text-green-600" />
      <StatCard icon={Users} label="Recorrentes" value={stats.returning_leads} color="text-purple-600" />
      <StatCard icon={Heart} label="Consentimento GDPR" value={stats.marketing_consent_count} color="text-red-500" />
      <StatCard icon={Instagram} label="Cliques Instagram" value={stats.instagram_clicked_count} color="text-pink-500" />
      <StatCard icon={MapPin} label="Check-ins" value={stats.checkin_clicked_count} color="text-orange-500" />
      <StatCard icon={Star} label="Avaliações Google" value={stats.google_review_clicked_count} color="text-yellow-500" />
    </div>
  );
}
